import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Toggle from '../shared/Toggle';
import './TopBar.css';

function formatLastActive(iso) {
  if (!iso) return 'Active now';
  const diffMs = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 2) return 'Active now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
}

export default function TopBar({ onMenuOpen }) {
  const { user } = useAuth();
  const location = useLocation();

  const initials = user?.name
    ? user.name.split(' ').map((n) => n[0]).join('').toUpperCase().slice(0, 2)
    : '?';

  return (
    <header className="topbar">
      <div className="topbar__inner">
        <div className="topbar__left">
          <Link to="/app/dashboard" className="topbar__logo" aria-label="fitndex home">
            fitndex
          </Link>
        </div>

        <div className="topbar__right">
          <Toggle />
          <Link
            to="/app/profile"
            className={`topbar__avatar ${location.pathname === '/app/profile' ? 'topbar__avatar--active' : ''}`}
            aria-label="Profile and settings"
          >
            <span className="topbar__avatar-initials">{initials}</span>
            {user && (
              <span className="topbar__dot-wrap" aria-hidden="true">
                <span className="topbar__active-dot" />
                <span className="topbar__activity-tip">{formatLastActive(user.lastActive)}</span>
              </span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
}
